<app-information-popup [page]="InformationPopupPage.GuidedTroubleshooting"></app-information-popup>

<div *ngIf="!(activeErrorsStore.isAnyActiveErrorLoading$ | async)" class="flex flex-col gap-[24px]">
  <ng-container *ngIf="activeErrorsStore.hasAnyActiveErrorDetails$ | async">
    <app-active-errors-list></app-active-errors-list>
    <app-active-error-details></app-active-error-details>
    <app-active-error-diagnostics></app-active-error-diagnostics>
  </ng-container>
</div>
